export class StudentDetails {

    GivenName: string;
    FamilyName: string;
    OnlyHasOneName: boolean;
    PreferredName: string;
    Gender: string;
    DateOfBirth: string;
    CountryOfBirthId: string;
    CountryOfNationalityId: string;
    HasPassport: boolean;
    PassportNumber: string;
    PassportExpiryDate:  string;
    EmailAddress: string;

    MobileCountryCode: string;
    MobilePhoneNumber: string;
    HomeCountryCode: string;
    HomePhoneNumber: string;

    AustralianAddressLine1: string;
    AustralianAddressLine2: string;
    AustralianSuburb: string;
    AustralianState: string;
    AustralianPostcode: string;
    IsAustralianAddressCurrentAddress: boolean;

    OverseasAddressLine1: string;
    OverseasAddressLine2: string;
    OverseasSuburbTown: string;
    OverseasStateProvinceRegion: string;
    OverseasPostcode: string;
    OverseasCountryId: string;
    IsOverseasAddressCurrentAddress: boolean;

    IsStudentAlreadyEnrolledInAustralia?: boolean;
    StudentLivingWith: string;    
}
